export default __webpack_public_path__ + "static/media/webImg.5d439f37.png";